
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, April 23, 2018
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedpresetmanagerpermissions",
	init: init,
	uninit: uninit,
	listeners: listeners,

	setPresets: setPresets,
	trackChanges: trackChanges,
	refresh: refresh,
	_who: null,
	_group: ""
});

function init() {
	this._tracker = this.dispatcher.createTracker();
	this.push(null);
}

function uninit() {
	this._tracker.off();
	this._tracker = null;
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"managedaccount:updated": handle_managedaccount_update,
		"managedusergroup:updated": handle_managedgroup_update
	};
}

function refresh() {
	if (!this._who) return;
	this.api.manage.manage.permissions.presets(this._who, this._group).then(setPresets.bind(this));
}

function setPresets(data) {
	this.push(data);
}

function handle_managedaccount_update(data) {
	var who = data.data._id;
	const group = data.group;
	this._group = group;

	if (this._who === who) return;
	this._who = who;
	this.refresh();
}

function handle_managedgroup_update(data) {
	var group = data;
	this.trackChanges(group);
}

function trackChanges(group) {
	var tracker = this._tracker;
	tracker.off();
	tracker.on("mqtt:orggroup/" + group + "/preset/manager/permissions/updated", handle_preset_updated.bind(this));
	tracker.on("mqtt:orggroup/" + group + "/preset/manager/permissions/created", handle_preset_created.bind(this));
	tracker.on("mqtt:orggroup/" + group + "/preset/manager/permissions/removed", handle_preset_removed.bind(this));
}

function handle_preset_created(data) {
	const oldList = this.data || [];
	const updatedList = [...oldList];
	updatedList.push(data);
	this.setPresets(updatedList);
}

function handle_preset_updated(data) {
	const oldList = this.data || [];
	const updatedList = [...oldList];

	const index = updatedList.findIndex((item) => item._id === data._id);

	if (index >= 0) {
		const oldItem = updatedList[index];
		const newItem = Object.assign({}, oldItem, data.data);
		updatedList[index] = newItem;
	}
	this.setPresets(updatedList);
}

function handle_preset_removed(id) {
	const oldList = this.data || [];
	const updatedList = [...oldList];
	const index = updatedList.findIndex((item) => item._id === id);
	if (index >= 0) {
		updatedList.splice(index, 1);
		this.setPresets(updatedList);
	}
}